import Joi from "joi-browser";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import HandlingResponse from "../../../common/handling-response/handlingResponse";
import {
  handleSave,
  serverValidation,
  validateForm,
} from "../../../common/validation/validation";
import LegalAreaClient from "../../api-services/coders/legal-area/legal-area.client";
import Moment from "moment";

const CreateLegalField = ({ row, handleCallback, isCreate }) => {
  var { t } = useTranslation();
  const client = new LegalAreaClient();

  const [errors, setErrors] = useState({});
  const [legalField, setLegalField] = useState({
    id: 0,
    name: "",
    weight: 0,
    userGuid: "",
    isActive: true,
    userFullName: "",
    lastModifyDate: null,
  });

  const schema = {
    name: Joi.string().required(),
    weight: Joi.number().min(0).max(2147483647).required(),
  };

  useEffect(() => {
    setLegalField(row);
    setErrors({});
  }, [row, isCreate]);

  const CreateLegalArea = async () => {
    const data = {
      id: 0,
      name: legalField.name,
      weight: legalField.weight,
      isActive: legalField.isActive,
      lastModifyDate: new Date(),
    };
    const result = validateForm(data, schema, t);
    var response = await client.CreateLegalArea(data);
    serverValidateAction(response);
    setErrors(result);
  };

  const UpdateLegalArea = async () => {
    const data = {
      id: legalField.id,
      name: legalField.name,
      weight: legalField.weight,
      isActive: legalField.isActive,
      lastModifyDate: new Date(),
    };
    const result = validateForm(data, schema, t);
    var response = await client.UpdateLegalArea(legalField.id, data);
    serverValidateAction(response);
    setErrors(result);
  };

  const serverValidateAction = (response) => {
    var handledResponse = HandlingResponse(response);
    if (handledResponse.code == 408) {
      var result = serverValidation(handledResponse.data, t);
      setErrors(result);
    } else handleCallback(handledResponse);
  };

  const handlePropertyChange = (event) => {
    const obj = { name: event.name, value: event.value };
    const result = handleSave(obj, legalField, errors, schema, t);
    setLegalField(result.data);
    setErrors(result.errors);
  };

  return (
    <>
      <form>
        <div className="form-group">
          <label>Назив<span className="required-asterisk">*</span></label>
          <input
            className="form-control"
            type="text"
            name="name"
            value={legalField.name}
            onChange={(event) => handlePropertyChange(event.target)}
          />
          {errors?.name && <div className="text-danger">{errors.name}</div>}
        </div>
        <div className="form-group">
          <label>Тежина</label>
          <input
            className="form-control"
            name="weight"
            type="number"
            value={legalField.weight}
            onChange={(event) => handlePropertyChange(event.target)}
          />
          {errors?.weight && <div className="text-danger">{errors.weight}</div>}
        </div>
        <div className="form-group">
          <input
            id="activeLegalFieldsCB"
            type="checkbox"
            name="isActive"
            value={legalField.isActive}
            checked={legalField.isActive}
            onChange={(event) =>
              setLegalField({ ...legalField, isActive: event.target.checked })
            }
          />
          <label htmlFor="activeLegalFieldsCB">Активна</label>
        </div>
        {!isCreate ? (
          <>
            <div className="form-group">
              <label>Идентификатор</label>
              <div>{legalField.id}</div>
            </div>
            <div className="form-group">
              <label>Корисник</label>
              <div>{legalField.userFullName}</div>
            </div>
            <div className="form-group">
              <label>Датум и време последње измене</label>
              <div>
                {Moment(legalField.lastModifyDate).format("DD.MM.YYYY.")}
              </div>
            </div>
          </>
        ) : (
          ""
        )}
        <div className="text-right">
          {isCreate ? (
            <button
              className="btn btn-primary m-2"
              type="button"
              onClick={() => CreateLegalArea()}
            >
              Сачувај
            </button>
          ) : (
            <button
              className="btn btn-primary m-2"
              type="button"
              onClick={() => UpdateLegalArea()}
            >
              Сачувај измене
            </button>
          )}
        </div>
      </form>
    </>
  );
};

export default CreateLegalField;
